var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLockDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1013 10.3385H17.2566V7.76659C17.2566 5.13854 15.1185 3 12.4906 3C9.86177 3 7.72409 5.13825 7.72409 7.76659V10.3385H6.87971C6.39374 10.3385 6 10.7324 6 11.2182V19.9463C6 20.4321 6.39374 20.826 6.87971 20.826H18.1013C18.5863 20.826 18.981 20.4321 18.981 19.9463V11.2182C18.981 10.7324 18.5862 10.3385 18.1013 10.3385ZM9.48333 7.76659C9.48333 6.10809 10.8321 4.75929 12.4906 4.75929C14.1487 4.75929 15.4975 6.10809 15.4975 7.76659V10.3385H9.48333V7.76659Z",
    fill: "#3A3C45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLockDark);
export default __webpack_public_path__ + "static/media/ic-lock-dark.75c4cf1ed4aafe9decd2e343d9289ad9.svg";
export { ForwardRef as ReactComponent };